import { render, staticRenderFns } from "./project.vue?vue&type=template&id=312012d2&scoped=true&"
import script from "./project.vue?vue&type=script&lang=ts&"
export * from "./project.vue?vue&type=script&lang=ts&"
import style0 from "./project.vue?vue&type=style&index=0&id=312012d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312012d2",
  null
  
)

component.options.__file = "project.vue"
export default component.exports